module.exports = __webpack_public_path__ + "img/register.4d186bff.svg";